import { AgentDefinition } from 'app/modules/agent-library/models/agent-definition.model';
import { DEO_TARGET_ID, TalkingToTarget } from '../models/talking-to-target.model';

/**
 * The "Talking to" rows: DEO first, then the agents a planner can talk to.
 *
 * Filtered on `isAvailable`, which is the prototype's own rule — except that the selected agent is
 * always included. Ask DEO can hand over an agent that is not released yet (two of the three waiting
 * anomalies are owned by roadmap agents), and dropping it would leave the trigger naming an agent
 * the list does not contain.
 *
 * `resolveMark` is `AgentsService.resolveAgentMark`, passed in rather than imported so the agent
 * library keeps knowing nothing about the assistant's selector.
 */
export function buildTalkingToTargets(agents: AgentDefinition[], selectedId: string, resolveMark: (name: string) => string): TalkingToTarget[] {
  const shown = agents.filter(agent => agent.isAvailable || agent.id === selectedId);

  return [
    {
      id: DEO_TARGET_ID,
      label: 'DEO AI Assist',
      mark: 'DEO'
    },
    ...shown.map(agent => ({
      id: agent.id,
      label: agent.name,
      mark: resolveMark(agent.name),
      agent
    }))
  ];
}
